export const environment = {
  production: true,
  apiUrl: 'api.shinycolors.moe',
  cloudFlareUrl: 'cf-static.shinycolors.moe',
  eventViewerUrl: 'event.shinycolors.moe',
};
